/**
 * Get current date/time in project's timezone
 * @param timezoneOffset - Timezone offset like "UTC+01:00" or "+09:00"
 */
const getCurrentDateInProjectTimezone = (timezoneOffset) => {
    const now = new Date();
    if (!timezoneOffset) {
        return now; // Fallback to browser's local time
    }
    // Extract offset hours and minutes from format like "UTC+01:00" or "+09:00"
    const offsetStr = timezoneOffset.replace("UTC", "");
    const offsetMatch = offsetStr.match(/([+-])(\d{1,2}):?(\d{2})?/);
    if (!offsetMatch) {
        return now; // Invalid format, fallback to browser time
    }
    const sign = offsetMatch[1] === "+" ? 1 : -1;
    const hours = parseInt(offsetMatch[2], 10);
    const minutes = parseInt(offsetMatch[3] || "0", 10);
    const totalOffsetMinutes = sign * (hours * 60 + minutes);
    // Get UTC time and apply project timezone offset
    const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
    const projectTime = new Date(utcTime + totalOffsetMinutes * 60000);
    return projectTime;
};
export const getDateRangeFromSelection = (selectedValue, customStartDate, customEndDate, timezoneOffset) => {
    // Get "now" in the project's timezone
    const now = getCurrentDateInProjectTimezone(timezoneOffset);
    let startDate;
    let endDate;
    switch (selectedValue) {
        case "Today": {
            // Use Date.UTC with local date components (matching transactions pattern)
            startDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
            endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            break;
        }
        case "Yesterday": {
            const yesterday = new Date(now);
            yesterday.setDate(now.getDate() - 1);
            startDate = new Date(Date.UTC(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0, 0));
            endDate = new Date(Date.UTC(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59, 999));
            break;
        }
        case "CurrentWeek": {
            // Get day of week from the project timezone date
            const dayOfWeek = now.getDay();
            const currentWeekStart = new Date(now);
            currentWeekStart.setDate(now.getDate() - dayOfWeek); // Sunday
            startDate = new Date(Date.UTC(currentWeekStart.getFullYear(), currentWeekStart.getMonth(), currentWeekStart.getDate(), 0, 0, 0, 0));
            endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            break;
        }
        case "PreviousWeek": {
            // Get day of week from the project timezone date
            const dayOfWeek = now.getDay();
            const currentWeekStart = new Date(now);
            currentWeekStart.setDate(now.getDate() - dayOfWeek); // Sunday
            const previousWeekStart = new Date(currentWeekStart);
            previousWeekStart.setDate(currentWeekStart.getDate() - 7);
            startDate = new Date(Date.UTC(previousWeekStart.getFullYear(), previousWeekStart.getMonth(), previousWeekStart.getDate(), 0, 0, 0, 0));
            const previousWeekEnd = new Date(currentWeekStart);
            previousWeekEnd.setDate(currentWeekStart.getDate() - 1);
            endDate = new Date(Date.UTC(previousWeekEnd.getFullYear(), previousWeekEnd.getMonth(), previousWeekEnd.getDate(), 23, 59, 59, 999));
            break;
        }
        case "Last7Days": {
            const last7DaysStart = new Date(now);
            last7DaysStart.setDate(now.getDate() - 6);
            startDate = new Date(Date.UTC(last7DaysStart.getFullYear(), last7DaysStart.getMonth(), last7DaysStart.getDate(), 0, 0, 0, 0));
            endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            break;
        }
        case "Last30Days": {
            const last30DaysStart = new Date(now);
            last30DaysStart.setDate(now.getDate() - 29);
            startDate = new Date(Date.UTC(last30DaysStart.getFullYear(), last30DaysStart.getMonth(), last30DaysStart.getDate(), 0, 0, 0, 0));
            endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            break;
        }
        case "CurrentMonth": {
            startDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0));
            endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            break;
        }
        case "CustomDate": {
            if (customStartDate && customEndDate) {
                const start = new Date(customStartDate);
                const end = new Date(customEndDate);
                startDate = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0));
                endDate = new Date(Date.UTC(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999));
            }
            else {
                // Default to last 7 days if custom dates not provided
                const last7DaysStart = new Date(now);
                last7DaysStart.setDate(now.getDate() - 6);
                startDate = new Date(Date.UTC(last7DaysStart.getFullYear(), last7DaysStart.getMonth(), last7DaysStart.getDate(), 0, 0, 0, 0));
                endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            }
            break;
        }
        default: {
            // Default to last 7 days
            const last7DaysStart = new Date(now);
            last7DaysStart.setDate(now.getDate() - 6);
            startDate = new Date(Date.UTC(last7DaysStart.getFullYear(), last7DaysStart.getMonth(), last7DaysStart.getDate(), 0, 0, 0, 0));
            endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
            break;
        }
    }
    return { endDate, startDate };
};
